import React, { useCallback, useEffect, useState } from "react";
import { TimerContext } from "./timer-context";
import { formatTime } from "../../utils/format-time";

type Props = {
  children?: React.ReactNode;
};

const TimerContextProvider: React.FC<Props> = ({ children }) => {
  const DEFAULT_TIMER_DURATION = 900; // default timer duration is 900 seconds or 15 minutes
  const [timeRemainingInSeconds, setTimeRemainingInSeconds] = useState(0);

  const [hasTimerStarted, setHasTimerStarted] = useState(false);
  const [isTimerPaused, setIsTimerPaused] = useState(false);

  const tick = useCallback(() => {
    setTimeRemainingInSeconds((prevSeconds) => {
      const newSeconds = prevSeconds - 1;
      return newSeconds;
    });
  }, []);

  useEffect(() => {
    if (timeRemainingInSeconds > 0 && hasTimerStarted && !isTimerPaused) {
      const timerId = setInterval(tick, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeRemainingInSeconds, tick, hasTimerStarted, isTimerPaused]);

  const startTimer = useCallback((duration = DEFAULT_TIMER_DURATION) => {
    // Your timer logic here
    setHasTimerStarted(true);
    setTimeRemainingInSeconds(duration);
  }, []);

  const stopTimer = useCallback(() => {
    // Your timer logic here
    setTimeRemainingInSeconds(0);
  }, []);

  const pauseTimer = useCallback(() => {
    // Your timer logic here
    setIsTimerPaused(true);
  }, []);

  const resetTimer = useCallback(() => {
    setHasTimerStarted(false); //
    setIsTimerPaused(false);
  }, []);

  const timeRemainingInMinutesText = formatTime(timeRemainingInSeconds);
  return (
    <TimerContext.Provider
      value={{
        timeRemainingInMinutesText,
        timeRemainingInSeconds,
        startTimer,
        stopTimer,
        hasTimerStarted,
        isTimerPaused,
        pauseTimer,
        resetTimer,
      }}
    >
      {children}
    </TimerContext.Provider>
  );
};

export default TimerContextProvider;
